import { gBrightnessThreshold } from "../constants";
import { DetermineBrightness } from "./DetermineBrightness";

export function DetermineTextColor(color) {
  return DetermineBrightness(color) < gBrightnessThreshold ? "#F2F2F2" : "#111111";
}
